/**
 * mix 方法
 * @param  {...any} mixins
 * @returns
 */
function mix(...mixins) {
  class Mix {}
  for (let mixin of mixins) {
    copyProperties(Mix.prototype, mixin); // 拷贝实例属性
    copyProperties(Mix.prototype, Reflect.getPrototypeOf(mixin)); // 拷贝原型属性
  }
  return Mix;
}
/**
 * 拷贝属性
 * @param {*} target
 * @param {*} source
 */
function copyProperties(target, source) {
  for (let key of Reflect.ownKeys(source)) {
    if (key !== 'constructor' && key !== 'prototype' && key !== 'name') {
      let desc = Object.getOwnPropertyDescriptor(source, key);
      Object.defineProperty(target, key, desc);
    }
  }
}

let classArray = [];
import serviceConfig from '@/service/service.json';
serviceConfig.forEach(io => {
  let cls = require(`@/service/${io}`);
  classArray.push(new cls.default());
});
/**
 * @class Service
 */
export default class extends mix(...classArray) {
  constructor() {
    super();
  }
}
